import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationAffiliateTransactionsGet = {
    path: "/affiliate/transactions",
    method: ERouteHttpVerb.GET
};
export { routeLocationAffiliateTransactionsGet };
